module.exports = __webpack_public_path__ + "img/上下翻转2.4faad189.svg";